import { jsx as _jsx } from "react/jsx-runtime";
const PageMainContent = ({ children }) => {
    return (_jsx("main", { className: "page-content", children: _jsx("div", { className: "container", children: children }) }));
};
export default PageMainContent;
